module.exports = __webpack_public_path__ + "img/logo-white.351d8083.png";